// extracted by mini-css-extract-plugin
export var dateLabel = "_2c-0";
export var dateLabelError = "_2c-1";
export var fullWidth = "_2c-2";
export var smaller = "_2c-3";